export const PostHashTagHandler = () => {
	const hash = window.location.hash.substr(1);
	if (hash) {
		const el = document.querySelector(`[data-post-id="${hash}"]`);
		if (el) {
			el.scrollIntoView({
				behavior: 'smooth',
				block: 'end',
				inline: 'nearest',
			});
		}
	}
};
